// app/(main)/page.tsx
import {  useState } from "react";
import { PageContainer } from "../../components/ui/PageContainer";
import Hero from "../../components/sections/home/Hero";
import SectorsSection from "../../components/sections/home/SectorsSection";

import { useSectors } from "@cabukaka/hooks";
import PageHead from "../../components/ui/PageHead";
import { CitySelectorBar } from "../../components/sections/home/CitySelectorBar";

// Configuration SEO
const pageMetadata = {
  title: "Cabukaka - Achetez dans vos boutiques préférées",
  description: "Découvrez les meilleures boutiques et produits à Bunia et Butembo.",
  url: "https://cabukaka.com",
  siteName: "Cabukaka",
  image: "https://cabukaka.com/og-home.jpg",
};

export default function HomePage() {
 

  // États pour la ville et le menu (nécessaires pour CitySelectorBar)
  const [selectedCity, setSelectedCity] = useState("Bunia");

  const { sectors, loading: sectorLoading } = useSectors({ page: 1 });


  const isLoading =  sectorLoading ;

  if (isLoading) {
    return (
      <PageContainer className="min-h-screen bg-gray-50">
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        </div>
      </PageContainer>
    );
  }

  return (
    <>
      <PageHead {...pageMetadata} />

      <PageContainer className="min-h-screen bg-gray-50">
        {/* Barre de sélection ville mobile */}
        <CitySelectorBar
          selectedCity={selectedCity}
          onCityChange={(city) => {
            setSelectedCity(city);
            localStorage.setItem("selectedCity", city);
          }}
        />

        {/* Hero Section */}
        <Hero />

        <SectorsSection
          sectors={sectors}
          title="Nos secteurs d'activité"
          subtitle="Des milliers de produits à portée de clic"
        />

        
      </PageContainer>
    </>
  );
}